import { Router } from '@okapi/router-react';
import React from 'react';
import { StoreContext } from 'storeon/react';
import { Baseline } from 'common/components';
import { SeasonStart } from 'landings/season-start';
import { RemoteProps } from './widgets-types';

export const SeasonStartRemote: React.FC<RemoteProps> = ({ router, store }) => (
  /* @ts-expect-error: Router typecheck error */
  <Router router={router}>
    <Baseline>
      <StoreContext.Provider value={store}>
        <SeasonStart />
      </StoreContext.Provider>
    </Baseline>
  </Router>
);

